import React from 'react';
import { withRouter } from "react-router";
import Tabs from '../../layouts/Tabs';
import ExerciseLibrary from './ExerciseLibrary';
import Icon from '@material-ui/core/Icon';
import ModalButton from '../../components/atomic/Buttons/ModalButton';
import CreateExerciseModal from '../../components/molecule/Modals/CreateExerciseModal'; 
import { getTabIndex } from '../../utils';

const baseRoute = '/exercises';
const Exercise = ({
  history,
  match,
}) => {
  const redirectToExerciseForm = data => {
    const uid = data.id;
    history.push(`${baseRoute}/${uid}`)
  }

  const tabs = [
    {
      label: 'Library',
      component: <ExerciseLibrary modalComponent={(<CreateExerciseModal onSuccess={redirectToExerciseForm} />)}/>,
      path: `${baseRoute}`
    },
  ];

  return (
    <Tabs
      value={getTabIndex(match.url,tabs)}
      tabComponents={tabs}
      sideComponent={[
        <ModalButton key='add_exercise' variant='contained' color='secondary' modalComponent={(<CreateExerciseModal onSuccess={redirectToExerciseForm} />)}>
          <Icon>add</Icon> Add
        </ModalButton>
      ]}
    />
  )
}

export default withRouter(Exercise);
